import ArrowRight from '../../src/legacy/ArrowRight';
export default ArrowRight;
